import { capitalize } from "@core/utils";
import type { ItemCategory } from '@src/types'
import type { ReservaProduct } from "./types";

export const getItemCategory = (item: ReservaProduct): ItemCategory => {
  const categories = item?.similarItems?.[0]?.categories;
  if (!categories?.length) return "Coleção";

  const match = categories.join(" ").match(/outlet|bazar|sale/i)?.[0].toLowerCase();
  return (match as ItemCategory) ?? "Coleção";
};

export const getItemCategory2 = (item: ReservaProduct): string => {
  const AVOID_CATEGORIES = /^(outlet|bazar|sale|coleção|promoção)$/i;
  const categories = item?.similarItems?.[0]?.categories ?? [];
  const validHierarchy = categories.filter((c) => c && !AVOID_CATEGORIES.test(c));
  const deepest = validHierarchy[validHierarchy.length - 1] ?? "";
  return capitalize(deepest) ?? "";
};